import type { PropsWithChildren } from 'react';

import { useHubSpotDemoLink } from './useHubSpotDemoLink';

type HubSpotDemoLinkProps = { className?: string };

export const HubSpotDemoLink = (props: PropsWithChildren<HubSpotDemoLinkProps>) => {
  const { className, children } = props;
  const { openHubSpotDemoLink } = useHubSpotDemoLink();

  return (
    <button type="button" className={className} onClick={openHubSpotDemoLink}>
      {children}
    </button>
  );
};
